import { EDITOR_SHOW_BUILDER_LOADER } from './constants';

export function showBuilderLoader() {
  return {
    type: EDITOR_SHOW_BUILDER_LOADER,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_SHOW_BUILDER_LOADER:
      return {
        ...state,
        showBuilderCanvasLoader: true,
      };

    default:
      return state;
  }
}
